import React, {Component} from 'react';
import {connect} from 'react-redux';
import WorkerSelector from './WorkerSelector';
import MonthSchedulePanel from './MonthSchedulePanel';
import { fetchPositionList } from 'actions/UserActions.js';

class Worker extends Component {

  componentDidMount() {
    this.props.dispatch(fetchPositionList());
  }

  render() {
    let {
      userList,
      selected,
      positionList,
      dispatch,
      year,
      month,
      siteList,
      dailySalary,
      salaryAdjust,
      adjustmentTypeList,
      shiftRecord,
      sessionConfig,
      companyList,
      loadingUserData
    } = this.props;

    const matchUser = userList.find(u => u.get('uid') == selected);

    return (
      <div className="worker-panel">
        <WorkerSelector
          userList={userList}
          selected={selected}
          companyList={companyList}
          positionList={positionList}
          dispatch={dispatch} 
          loadingUserData={loadingUserData} />
        {
          (selected > 0 ? 
            <MonthSchedulePanel
              year={year}
              month={month}
              dailySalary={dailySalary}
              salaryAdjust={salaryAdjust}
              adjustmentTypeList={adjustmentTypeList}
              shiftRecord={shiftRecord}
              sessionConfig={sessionConfig}
              selected={selected}
              positionList={positionList}
              user={matchUser}
              siteList={siteList}
              dispatch={dispatch}
              loadingUserData={loadingUserData}  />
            :
            <h1>沒有選取的員工</h1>
          )
        }
      </div>
    )
  }
}

export default connect((state) => ({
  userList: state.user.get('userList'),
  selected: state.user.get('selected'),
  positionList: state.user.get('positionList'),
  companyList: state.company,
  year: state.user.get('year'),
  month: state.user.get('month'),
  dailySalary: state.user.getIn(['selectedUserInfo', 'dailySalary']),
  salaryAdjust: state.user.getIn(['selectedUserInfo', 'salaryAdjust']),
  shiftRecord: state.user.getIn(['selectedUserInfo', 'shiftRecord']),
  siteList: state.construction.get('constructionList'),
  adjustmentTypeList: state.salary.get('adjustmentTypeList'),
  sessionConfig: state.session.get('config'),
  loadingUserData: state.user.get('loadingUserData'),
}))(Worker);



// WEBPACK FOOTER //
// ./src/components/Worker/Worker.js